/**
 * Funciones de validación para archivos
 */

/**
 * Normaliza el formato de accept para compatibilidad con react-dropzone
 * Convierte string antiguo a formato objeto requerido por la librería
 * @param {string|Object} accept - Formato de aceptación de archivos
 * @returns {Object} Formato normalizado para react-dropzone
 */
export const normalizeAccept = (accept) => {
    if (typeof accept === 'string') {
        if (accept === '*' || accept === '*/*') {
            return {}; // Acepta todo
        }
        // Convertir string a objeto react-dropzone
        return { [accept]: [] };
    }
    return accept;
};

/**
 * Obtiene mensaje de error apropiado según el código
 * @param {string} errorCode - Código de error de react-dropzone
 * @param {number} maxSize - Tamaño máximo permitido en bytes
 * @returns {string} Mensaje de error localizado
 */
export const getErrorMessage = (errorCode, maxSize) => {
    switch (errorCode) {
        case 'file-too-large':
            return `Archivo muy grande. Máximo ${maxSize / 1048576}MB`;
        case 'file-invalid-type':
            return 'Tipo de archivo no permitido. Solo imágenes.';
        default:
            return 'Error al subir archivo';
    }
};

/**
 * Determina el formato accept para input HTML nativo de cámara
 * @param {string|Object} accept - Formato de aceptación de archivos
 * @returns {string} Formato accept para input HTML
 */
export const getCameraAccept = (accept) => {
    return typeof accept === 'string' ? accept : 'image/*';
};

/**
 * Detecta si el dispositivo actual es móvil
 * @returns {boolean} true si es dispositivo móvil (Android, iPhone, iPad, iPod)
 */
export const isMobileDevice = () => {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
};
